import { useTranslation } from 'react-i18next';

export default function ValuesSection() {
  const { t } = useTranslation();
  const values = [
    { icon: 'ri-service-line', title: t('aboutPage.values.v0.title'), subtitle: t('aboutPage.values.v0.subtitle'), desc: t('aboutPage.values.v0.desc'), color: '#FF2D78', features: [t('aboutPage.values.v0.f0'), t('aboutPage.values.v0.f1'), t('aboutPage.values.v0.f2')] },
    { icon: 'ri-building-4-line', title: t('aboutPage.values.v1.title'), subtitle: t('aboutPage.values.v1.subtitle'), desc: t('aboutPage.values.v1.desc'), color: '#FF8C42', features: [t('aboutPage.values.v1.f0'), t('aboutPage.values.v1.f1'), t('aboutPage.values.v1.f2')] },
    { icon: 'ri-loop-right-line', title: t('aboutPage.values.v2.title'), subtitle: t('aboutPage.values.v2.subtitle'), desc: t('aboutPage.values.v2.desc'), color: '#FF2D78', features: [t('aboutPage.values.v2.f0'), t('aboutPage.values.v2.f1'), t('aboutPage.values.v2.f2')] },
  ];
  const differentiators = [
    { icon: 'ri-stack-line', title: t('aboutPage.values.d0.title'), desc: t('aboutPage.values.d0.desc') },
    { icon: 'ri-global-line', title: t('aboutPage.values.d1.title'), desc: t('aboutPage.values.d1.desc') },
    { icon: 'ri-git-fork-line', title: t('aboutPage.values.d2.title'), desc: t('aboutPage.values.d2.desc') },
    { icon: 'ri-customer-service-2-line', title: t('aboutPage.values.d3.title'), desc: t('aboutPage.values.d3.desc') },
  ];

  return (
    <section className="bg-light-section py-24 relative overflow-hidden">
      <div className="relative max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
            <i className="ri-heart-line text-accent text-sm" />
            <span className="text-accent text-xs font-medium uppercase tracking-wider">{t('aboutPage.values.tag')}</span>
          </div>
          <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-4">
            {t('aboutPage.values.title')}
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            {t('aboutPage.values.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-20">
          {values.map((v, i) => (
            <div key={i} className="group bg-white border border-primary/10 rounded-2xl p-8 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-px opacity-60" style={{ background: `linear-gradient(to right, transparent, ${v.color}, transparent)` }} />
              <div className="w-14 h-14 flex items-center justify-center rounded-xl mb-6" style={{ backgroundColor: `${v.color}12`, border: `1px solid ${v.color}25` }}>
                <i className={`${v.icon} text-2xl`} style={{ color: v.color }} />
              </div>
              <h3 className="text-xl font-heading font-bold text-gray-900 mb-1">{v.title}</h3>
              <p className="text-xs text-gray-400 font-mono mb-4">{v.subtitle}</p>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">{v.desc}</p>
              <div className="space-y-2">
                {v.features.map((f, j) => (
                  <div key={j} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: v.color }} />
                    <span className="text-gray-600 text-xs">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="border border-primary/10 rounded-2xl p-8 md:p-12 bg-white">
          <h3 className="text-2xl font-heading font-bold text-gray-900 text-center mb-10">{t('aboutPage.values.diffTitle')}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
            {differentiators.map((d, i) => (
              <div key={i} className="text-center group">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 border border-primary/20 rounded-xl mx-auto mb-4 group-hover:bg-primary/20 transition-colors">
                  <i className={`${d.icon} text-primary text-xl`} />
                </div>
                <h4 className="text-sm font-bold text-gray-800 mb-2">{d.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{d.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
